import React from 'react'
import { ToggleSwitch } from '@/ui/components/atoms/ToggleSwitch'

interface SearchTabsProps {
  activeTab: 'customer' | 'dossier'
  onTabChange: (tab: 'customer' | 'dossier') => void
}

export const SearchTabs: React.FC<SearchTabsProps> = ({ activeTab, onTabChange }) => {
  const customerIcon = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  )

  const dossierIcon = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
      <polyline points="10 9 9 9 8 9"/>
    </svg>
  )

  const options = [
    { value: 'customer', label: 'Rechercher un Client', icon: customerIcon },
    { value: 'dossier', label: 'Rechercher un Dossier', icon: dossierIcon }
  ] as [any, any] // Type assertion for tuple

  return (
    <ToggleSwitch
      options={options}
      value={activeTab}
      onChange={(value) => onTabChange(value as 'customer' | 'dossier')}
      size="medium"
      colorScheme="default"
      aria-label="Search type selector"
    />
  )
}